
<button class="cursor" style="display: block !important;" role="button" [matMenuTriggerFor]="menu" (click)="$event.preventDefault();$event.stopPropagation()">
  <i class="fa fa-caret-down"></i>
</button>
<mat-menu #menu="matMenu">
  <div mat-menu-item (click)="clicked.emit('')">
    <span>{{'APPLICATIONS.COPY.VALUE_ON_OTHER_MARKETS' | translate }}</span>
  </div>
  <div mat-menu-item style="overflow: auto;height: auto;white-space: inherit;">
    {{'APPLICATIONS.COPY.VALUE_ON_MARKET' | translate }} : <br />
    <button mat-raised-button (click)="clicked.emit(marketMenu.name)" *ngFor="let marketMenu of marketList" style="margin: 0 5px;">
      {{marketMenu.name}}
    </button>
  </div>
</mat-menu>
